// Central content + brand data for HM Beacon

export const CONTACT = {
  email: "info@hmbeacon.com",
  phone: "+91 83683 70572",
  officeName: "Oafeo Co-working",
  officeLines: ["Shakti Nagar", "Delhi – 110009"],
};

export const NAV_LINKS = [
  { label: "Why HM Beacon", to: "/why" },
  { label: "Capabilities", to: "/capabilities" },
  { label: "Network", to: "/network" },
  { label: "Industries", to: "/industries" },
  { label: "Perspectives", to: "/perspectives" },
  { label: "Contact", to: "/contact" },
];

export const GLOBAL_PUBLICATIONS = [
  "Forbes", "The Wall Street Journal", "Reuters", "Bloomberg", "Business Insider",
  "TechCrunch", "USA Today", "The New York Times", "Time", "Entrepreneur",
  "Yahoo", "AP News", "VentureBeat", "Benzinga",
];

export const NATIONAL_MEDIA = [
  "The Times of India", "The Economic Times", "Mint", "Hindustan Times",
  "Business Today", "India Today", "The Hindu", "Financial Express",
  "Forbes India", "Outlook India", "Moneycontrol", "Business Standard",
  "News18", "ANI", "PTI", "Firstpost",
];

export const BROADCAST_MEDIA = [
  "CNBC", "Bloomberg Television", "ET Now", "Times Now",
  "News18", "Zee Business", "Republic", "India Today TV",
];

export const FORUM_OPPORTUNITIES = [
  "Speaking engagements", "Leadership panels", "Fireside conversations",
  "Executive roundtables", "Founder networking", "Strategic introductions",
];

export const NETWORK_INDUSTRIES = [
  "Artificial Intelligence", "Financial Services", "Healthcare & Life Sciences",
  "Data Centres", "Cybersecurity", "Enterprise Technology", "Manufacturing",
  "Infrastructure", "Mobility & EV", "Retail", "HR Technology", "Logistics",
  "Energy", "Sustainability", "Real Estate", "Venture Capital & Private Equity",
];

export const NETWORK_DISCLAIMER =
  "Publication, media, and organization names are referenced solely to illustrate the types of visibility ecosystems HM Beacon works within or can facilitate through its network. All trademarks remain the property of their respective owners. Their inclusion does not imply endorsement, affiliation, or partnership unless explicitly stated.";


export const AUTHORITY_FRAMEWORK = [
  { n: "01", title: "Visibility", body: "Becoming present in the specific arenas where your industry is discussed and shaped." },
  { n: "02", title: "Recognition", body: "Being consistently seen by the people who influence decisions, until presence becomes familiarity." },
  { n: "03", title: "Trust", body: "Earning credibility through relevance and consistency, not volume or noise." },
  { n: "04", title: "Authority", body: "Becoming a reference point — the organization the market turns to for perspective." },
  { n: "05", title: "Influence", body: "Shaping the conversation itself, so the industry moves in step with your thinking." },
];

export const BEACON_METHOD = [
  { n: "01", title: "Discover", body: "We study your market, your ambitions, and the perception you hold today." },
  { n: "02", title: "Map", body: "We map the ecosystem — the publications, platforms, communities, and decision-makers that matter." },
  { n: "03", title: "Position", body: "We define where you must be present and the narrative that earns you standing there." },
  { n: "04", title: "Activate", body: "We facilitate the placements, conversations, and relationships that move you into influence." },
  { n: "05", title: "Amplify", body: "We compound every moment of visibility into durable, institutional authority." },
];

export const CAPABILITIES = [
  {
    id: "executive-positioning",
    title: "Executive Positioning",
    outcome: "Put the right leaders into the conversations and platforms where their perspective carries weight.",
    points: ["Speaking", "Interviews", "Panels", "Roundtables", "Executive Profiles"],
  },
  {
    id: "industry-access",
    title: "Industry Access",
    outcome: "Connect organizations with the conferences, communities and industry platforms where important relationships are built.",
    points: ["Conferences", "Summits", "Executive Communities", "Associations", "Strategic Introductions"],
  },
  {
    id: "recognition",
    title: "Recognition",
    outcome: "Build credible third-party signals around leadership, achievement and organizational standing.",
    points: ["Awards", "Rankings", "Leadership Recognition", "Industry Honors"],
  },
  {
    id: "visibility-strategy",
    title: "Visibility Strategy",
    outcome: "Turn individual opportunities into a deliberate visibility roadmap designed to compound authority over time.",
    points: ["Ecosystem Mapping", "Positioning", "Opportunity Strategy", "Visibility Roadmap"],
  },
];

export const EDITORIAL_PLATFORMS = [
  "Forbes", "Forbes India", "Forbes US", "Fortune India", "Entrepreneur",
  "Entrepreneur India", "CNBC-TV18", "CNN-News18", "Moneycontrol", "Times Now",
  "Gulf News", "Khaleej Times", "Outlook", "HT Media", "ETCIO", "ETBFSI",
  "The Times of India", "ET Now",
];

export const EDITORIAL_DISCLAIMER =
  "Publication, media and organization names are referenced solely to illustrate the types of visibility ecosystems HM Beacon and its parent/group network have experience operating within or can facilitate access to. All trademarks remain the property of their respective owners. Their inclusion does not imply endorsement, affiliation, ownership or partnership unless explicitly stated.";

export const WHERE_GROUPS = [
  { title: "Media & Broadcast", items: ["Interviews", "Broadcast", "Podcasts", "Executive Profiles", "Branded Visibility"] },
  { title: "Executive Platforms", items: ["Speaking", "Panels", "Fireside Conversations", "Executive Roundtables", "Leadership Forums"] },
  { title: "Industry Ecosystems", items: ["Conferences", "Summits", "Associations", "Communities", "Strategic Networks"] },
  { title: "Recognition", items: ["Awards", "Rankings", "Leadership Programs", "Industry Honors"] },
];

export const EXECUTIVE_PLATFORMS = [
  "Executive Forums", "Leadership Summits", "Industry Conferences",
  "Private Roundtables", "Business Awards", "Executive Communities",
];

export const INDUSTRIES = [
  "Technology", "Artificial Intelligence", "Healthcare", "Financial Services",
  "Pharmaceuticals", "Manufacturing", "Infrastructure", "Energy", "Retail",
  "Consumer Brands", "Cybersecurity", "HR Technology", "Mobility", "Real Estate",
];

export const CLIENTS = [
  { name: "ABB", logo: "/clients/abb.png" },
  { name: "KPMG", logo: "/clients/kpmg.png" },
  { name: "Honeywell", logo: "/clients/honeywell.png" },
  { name: "J.B. Boda", logo: "/clients/jbboda.png" },
  { name: "Acuver Consulting", logo: "/clients/acuver.png" },
  { name: "EverestEngineering", logo: "/clients/everest.png" },
  { name: "SgurrEnergy", logo: "/clients/sgurr.png" },
  { name: "WAISL", logo: "/clients/waisl.png" },
  { name: "Step Global", logo: "/clients/stepglobal.png" },
  { name: "Kirloskar Technologies", logo: "/clients/kirloskar.png" },
  { name: "Doceree", logo: "/clients/doceree.png" },
  { name: "BTL India", logo: "/clients/btl.png" },
  { name: "Celsius Logistics", logo: "/clients/celsius.png" },
  { name: "SM Express", logo: "/clients/smexpress.png" },
  { name: "PM Relocations", logo: "/clients/pmr.png" },
  { name: "Eleganz Interiors", logo: "/clients/eleganz.png" },
  { name: "Infilect", logo: "/clients/infilect.png" },
  { name: "Centre for Sight", logo: "/clients/centreforsight.png" },
  { name: "Gensol", logo: "/clients/gensol.png" },
  { name: "Modern Informatics", logo: "/clients/modern.png" },
  { name: "sugar.fit", logo: "/clients/sugarfit.png", dark: true },
  { name: "Praan Health", logo: "/clients/praan.png", dark: true },
  { name: "RG Hospitals", logo: "/clients/rghospitals.png", dark: true },
];

export const IMAGES = {
  facade: "https://images.pexels.com/photos/23639035/pexels-photo-23639035.jpeg?auto=compress&cs=tinysrgb&w=1400",
  lines: "https://images.pexels.com/photos/10984489/pexels-photo-10984489.jpeg?auto=compress&cs=tinysrgb&w=1400",
  corner: "https://images.pexels.com/photos/3312276/pexels-photo-3312276.jpeg?auto=compress&cs=tinysrgb&w=1400",
  conferenceCrowd: "https://images.unsplash.com/photo-1540575467063-178a50c2df87?crop=entropy&cs=srgb&fm=jpg&w=1400&q=80",
  speaker: "https://images.unsplash.com/photo-1587825140708-dfaf72ae4b04?crop=entropy&cs=srgb&fm=jpg&w=1400&q=80",
  boardroom: "https://images.unsplash.com/photo-1431540015161-0bf868a2d407?crop=entropy&cs=srgb&fm=jpg&w=1400&q=80",
};
